import React from 'react'
import { Box } from '@mui/system'
import { RouteComponentProps, withRouter } from 'react-router-dom'

function ScrollToTop({ history }: RouteComponentProps) {
  const ref = React.useRef<HTMLElement>()

  React.useEffect(() => {
    const unlisten = history.listen(() => {
      const top = ref.current ? ref.current.offsetTop : 0
      window.scrollTo(0, top)
    })
    return () => {
      unlisten()
    }
  }, [history, ref])

  return <Box ref={ref} />
}

export default withRouter(ScrollToTop)
